import rangesliderJs from 'rangeslider-js';

export default class CustomRangeSlider {
   private inputs: HTMLInputElement[];
   constructor() {
      this.inputs = [...document.querySelectorAll('.form__range-input')] as HTMLInputElement[];

      this.initListeners();
   }

   init = async (): Promise<void> => {
      this.inputs.forEach((input) => {
         const inputValue = input.parentElement?.querySelector('.form__range-value');

         rangesliderJs.create(input, {
            min: parseInt(input.min),
            max: parseInt(input.max),
            value: parseInt(input.value),
            step: parseInt(input.dataset.step as string),
            onSlide: (value) => {
               if (inputValue) {
                  inputValue.textContent = value;
               }
            },
         });
      });
   };

   initListeners = async (): Promise<void> => {
      this.inputs.forEach((input) => input.addEventListener('change', this.handleInputChange));
   };

   handleInputChange = async (event: Event): Promise<void> => {
      const inputValue = (event.currentTarget as HTMLElement).parentElement?.querySelector('.form__range-value');

      if (!inputValue) return;

      inputValue.textContent = (event.currentTarget as HTMLInputElement).value;
   };
}
